import { render } from "./AppView.vue?vue&type=template&id=7c698ddc&scoped=true"
const script = {}

import "./AppView.vue?vue&type=style&index=0&id=7c698ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c698ddc"]])

export default __exports__